import { render, staticRenderFns } from "./ArticlePreview.vue?vue&type=template&id=5909e237&"
import script from "./ArticlePreview.vue?vue&type=script&lang=ts&"
export * from "./ArticlePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports